export default "__VITE_ASSET__Bj6NKoa0__"